module.exports = __webpack_public_path__ + "img/郑州大学logo.1632bc74.png";